import { createTheme } from '@mui/material/styles'
import { hcpDashboardPalette, hubDashboardPalette } from './dashboard-palette'

declare module '@mui/material/styles' {
  interface Palette {
    hubDashboard: typeof hubDashboardPalette
    hcpDashboard: typeof hcpDashboardPalette
  }
  interface PaletteOptions {
    hubDashboard?: typeof hubDashboardPalette
    hcpDashboard?: typeof hcpDashboardPalette
  }
}

const typography = {
  fontFamily: '"Montserrat", sans-serif',
}

const lightTheme = createTheme({
  typography,
  palette: {
    mode: 'light',
    primary: {
      main: '#84a802', // Cor primária no modo claro,
      dark: '#597007'
    },
    secondary: {
      main: '#9c27b0' // Cor secundária no modo claro
    },
    hubDashboard: hubDashboardPalette,
    hcpDashboard: hcpDashboardPalette,
    background: {
      default: '#f7f9fc', // Cor de fundo no modo claro
      paper: '#f5f5f5' // Cor de fundo dos papéis no modo claro
    },
    text: {
      primary: '#000000', // Cor do texto principal no modo claro,
      secondary: '#364152',
      
    },
   
  }
})

const darkTheme = createTheme({
  typography,
  palette: {
    mode: 'dark',
    primary: {
      main: '#90caf9' // Cor primária no modo escuro
    },
    secondary: {
      main: '#ce93d8' // Cor secundária no modo escuro
    },
    hubDashboard: hubDashboardPalette,
    hcpDashboard: hcpDashboardPalette,
    background: {
      default: '#121212', // Cor de fundo no modo escuro
      paper: '#1d1d1d' // Cor de fundo dos papéis no modo escuro
    },
    text: {
      primary: '#ffffff', // Cor do texto principal no modo escuro
      secondary: '#364152',
      
    }
  }
})

export { lightTheme, darkTheme }
